var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLixeira(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99951 6.00001L26.9995 6C27.5518 6 27.9995 6.44771 27.9995 7C27.9995 7.55228 27.5518 8 26.9995 8L4.99951 8.00001C4.44723 8.00001 3.99951 7.55229 3.99951 7.00001C3.99951 6.44772 4.44723 6.00001 4.99951 6.00001Z",
    fill: "#232840"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 12C13.5523 12 14 12.4477 14 13V21C14 21.5523 13.5523 22 13 22C12.4477 22 12 21.5523 12 21V13C12 12.4477 12.4477 12 13 12Z",
    fill: "#232840"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 12C19.5523 12 20 12.4477 20 13V21C20 21.5523 19.5523 22 19 22C18.4477 22 18 21.5523 18 21V13C18 12.4477 18.4477 12 19 12Z",
    fill: "#232840"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 6C7.55228 6 8 6.44772 8 7V26H24V7C24 6.44772 24.4477 6 25 6C25.5523 6 26 6.44772 26 7V26C26 26.5304 25.7893 27.0391 25.4142 27.4142C25.0391 27.7893 24.5304 28 24 28H8C7.46957 28 6.96086 27.7893 6.58579 27.4142C6.21071 27.0391 6 26.5304 6 26V7C6 6.44772 6.44772 6 7 6Z",
    fill: "#232840"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8787 2.87868C11.4413 2.31607 12.2044 2 13 2H19C19.7956 2 20.5587 2.31607 21.1213 2.87868C21.6839 3.44129 22 4.20435 22 5V7C22 7.55228 21.5523 8 21 8C20.4477 8 20 7.55228 20 7V5C20 4.73478 19.8946 4.48043 19.7071 4.29289C19.5196 4.10536 19.2652 4 19 4H13C12.7348 4 12.4804 4.10536 12.2929 4.29289C12.1054 4.48043 12 4.73478 12 5V7C12 7.55228 11.5523 8 11 8C10.4477 8 10 7.55228 10 7V5C10 4.20435 10.3161 3.44129 10.8787 2.87868Z",
    fill: "#232840"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLixeira);
export default __webpack_public_path__ + "static/media/lixeira.8d88511ae74c56ff7059386ba28afddb.svg";
export { ForwardRef as ReactComponent };